/**
 * The kinds of asset a Republic surface can present, sent as `asset_type` on
 * any event about one of them.
 *
 * Shared rather than owned by one page's event module: /investment-opportunities
 * and /funded-ventures both report it, so a single Segment query can union the
 * two and split by `source`.
 *
 * `OFFERING` and `FUNDED_OFFERING` are both GraphQL offerings and share a card;
 * they stay distinct because they answer different questions — live deals are a
 * conversion surface, funded deals are social proof.
 */
export const ASSET_TYPES = {
  RWA: 'rwa',
  CRYPTO: 'crypto',
  OFFERING: 'offering',
  FUNDED_OFFERING: 'funded_offering',
} as const;

export type TAssetType = (typeof ASSET_TYPES)[keyof typeof ASSET_TYPES];
